import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import {collapsed, isMobile, navbarWidth, toggleCollapse} from './navState';
import {headerHeight} from "@/components/global-header/headerState";
import { ref } from 'vue';

import RegistrationNav from './registration-nav.vue';
import ShoppingNav from './shopping-portal/shopping-nav.vue';
import BuilderNav from './builder-portal/builder-nav.vue';
import AdminNav from './admin/admin-nav.vue';

import emitter from '@/events';

import Version from './version.vue';


type Props = {
    portal: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'navbar-slot',
  props: {
    portal: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

_useCssVars(_ctx => ({
  "69a54fcd": (_unref(navbarWidth)),
  "d6b43686": (_unref(headerHeight))
}))

const props = __props;
const firstTime = ref(0);


function openWelcomeBack(){
    emitter.emit('openWelcomeBack');
}



const __returned__ = { props, firstTime, openWelcomeBack, get collapsed() { return collapsed }, get isMobile() { return isMobile }, get navbarWidth() { return navbarWidth }, get toggleCollapse() { return toggleCollapse }, get headerHeight() { return headerHeight }, ref, RegistrationNav, ShoppingNav, BuilderNav, AdminNav, get emitter() { return emitter }, Version }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})